import React, { useEffect, useState, useRef } from "react";
import {
  GoogleMap,
  Marker,
  InfoWindow,
  MarkerClusterer,
} from "@react-google-maps/api";
import SVG from "react-inlinesvg";
import View from "../assets/emergency_services/view.svg";

const mapContainerStyle = {
  width: "100%",
  height: window.innerWidth < 1080 ? "480px" : "450px",
};

export default function MapFuelFill(props) {
  const { locations1, selectVehicleNo } = props;
  const [mapType, setMapType] = useState("roadmap");
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState("");
  const mapRef = useRef(null);
  const [zoom] = useState(10);

  useEffect(() => {
    // Find the index of the selected vehicle based on its vehicle number
    const selectedIndex = locations1.findIndex(
      (markerData) => markerData.vehicleNo === selectVehicleNo
    );
    setSelectedMarkerIndex(selectedIndex !== -1 ? selectedIndex : null);
  }, [selectVehicleNo, locations1]);

  useEffect(() => {
    if (selectedMarkerIndex !== null && mapRef.current) {
      const bounds = new window.google.maps.LatLngBounds();
      if (
        locations1[selectedMarkerIndex]?.lat &&
        locations1[selectedMarkerIndex]?.lng
      ) {
        bounds.extend(
          new window.google.maps.LatLng(
            locations1[selectedMarkerIndex].lat,
            locations1[selectedMarkerIndex].lng
          )
        );
        mapRef.current.fitBounds(bounds);
      }
    } else {
      const bounds = new window.google.maps.LatLngBounds();
      if (locations1[0]?.lat && locations1[0]?.lng && mapRef.current) {
        bounds.extend(
          new window.google.maps.LatLng(locations1[0].lat, locations1[0].lng)
        );
        mapRef.current.fitBounds(bounds);
        mapRef.current.setZoom(10);
      }
    }
  }, [selectedMarkerIndex, locations1]);

  const toggleMapType = (type) => {
    if (type == "view-type") {
      const newMapType = mapType === "roadmap" ? "satellite" : "roadmap";
      setMapType(newMapType); // Update mapType state
    }
  };

  const mapOptions = {
    mapTypeId: mapType,
    zoomControl: false,
    streetViewControl: false, // Disable street view control
    fullscreenControl: false, // Disable fullscreen control
    mapTypeControl: false, // Disable map type control
    trafficControlOptions: {
      mapTypeIds: ["roadmap", "satellite"],
      // style: window.google.maps.TrafficStyle,
    },
  };

  const handleToggleInfoWindow = (index) => {
    setSelectedMarkerIndex(index);
  };

  return (
    <div>
      <div className="google-map-parent">
        <GoogleMap
          onLoad={(map) => (mapRef.current = map)}
          mapContainerStyle={mapContainerStyle}
          zoom={zoom}
          center={{
            lat: locations1[0]?.lat || 23,
            lng: locations1[0]?.lng || 73,
          }}
          options={mapOptions}
        >
          <MarkerClusterer>
            {(clusterer) =>
              locations1.map((markerData, index) => {
                // const icon = markerData.fuelTheft > 0 ? FuelThefticon: Fuelicon;
                return (
                  <Marker
                    key={markerData?.vehicleNo}
                    position={{ lat: markerData.lat, lng: markerData.lng }}
                    clusterer={clusterer}
                    onClick={() => handleToggleInfoWindow(index)}
                  >
                    {selectedMarkerIndex !== "" &&
                      selectedMarkerIndex == index && (
                        <InfoWindow
                          onCloseClick={() => {
                            handleToggleInfoWindow("");
                            mapRef.current.setZoom(10);
                          }} // Close info window on click outside
                        >
                          <div
                            style={{
                              color: "#fff",
                              width: "220px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                              marginTop: "20px",
                            }}
                            className="stops"
                          >
                            {/* <Link to={`/vehicles/${markerData.vehicleNo}`} state={{ id: markerData.id }} className="text-white font-600"> */}
                            <p className="mb-2">{markerData.address}</p>
                            {/* </Link> */}
                            <p className="mb-2 text-left">
                              FuelFill:{markerData.FuelConsumed}
                            </p>
                          </div>
                        </InfoWindow>
                      )}
                  </Marker>
                );
              })
            }
          </MarkerClusterer>
        </GoogleMap>
      </div>
      <div className="map-custom-icons-fuelfill">
        <div
          className={
            mapType == "roadmap"
              ? `image-container mt-3 mb-2`
              : `image-container-active mt-3 mb-2`
          }
          onClick={() => toggleMapType("view-type")}
        >
          <SVG src={View} width={"20px"} />
        </div>
      </div>
    </div>
  );
}
